// extracted by mini-css-extract-plugin
export default {"companyregisterthx":"companyregisterthx__6EMWf"};